export enum AlertType {
    Success = 'primary',
    Warning = 'warning',
    Danger = 'danger',
}

export default AlertType;
